/*
 * UNIVERSIDAD AUTONOMA DE AGUASCALIENTES
 * DIRECCION GENERAL DE PLANEACION Y DESARROLLO
 * DEPARTAMENTO DE SISTEMAS (OPTIMIZACION DE PROYECTOS ADMINISTRATIVOS - OPA)
 *
 * PROYECTO:  COMPRAS
 * PROPOSITO: Consultar todos los procedimientos existentes asi como filtrar los propios de un proveeedor ya firmado.
 *
 * AUTOR:     FZALDIVAR
 * FECHA:     10/Oct/2019
 *
*/
import { Component, OnInit } from '@angular/core';
import { ApiProcedimientosService } from 'src/app/services/api-procedimientos.service';
import { Router } from '@angular/router';
import { ApiRegistryService } from 'src/app/services/api-registry.service';
import { ApiAuthService } from 'src/app/services/api-auth.service';
import { Proveedor } from 'src/app/models/Proveedor';
import { isNullOrUndefined, debug } from 'util';
import { ApiParametrosService } from 'src/app/services/api-parametros.service';
import { Globals } from 'src/app/globals';

declare var $: any;

@Component({
  selector: 'app-procs',
  templateUrl: './procs.component.html',
  styleUrls: ['./procs.component.css']
})
export class ProcsComponent implements OnInit {

  public readonly PANTALLA: number = 3;                // Constante Id para esta pantalla
  public now: Date;
  public procedimientos: any[] = [];

  public mensajeError: string = '¡Error!';
  public error: number;

  constructor(private apiProcedimientos: ApiProcedimientosService, private apiRegistry: ApiRegistryService, private apiAuth: ApiAuthService,
              private router: Router, private apiParams: ApiParametrosService, public globals: Globals) {
      this.now = new Date();
  }

  ngOnInit() {
    $('#mod_procesando').modal('show');
    $('#div_ordenes').hide();
    this.getProveedor();
  }

  getProveedor(){
    let proveedor: any[] = [];
    let prov: Proveedor
    prov = this.apiAuth.getTokenDecoded();

    if (isNullOrUndefined(prov)) {
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#mod_error').modal('show');
      }, 500);

      return;
    }

    this.apiRegistry.getInformacionRfc(prov.RFC).subscribe(data => {
      if(data[0].success && data[0].info !== '{}' && data[0].info !== '[]') {
        proveedor = JSON.parse(data[0].info);
        this.readProcedimientos(this.now.getFullYear().toString(), this.PANTALLA, proveedor[0].PK_FKCPRCO, proveedor[0].PK_TIPO_PROVEEDOR);
      } else {
        this.mensajeError = data[0].msgRespuesta;
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
          $('#mod_error').modal('show');
        }, 500);
      }
    },
    error => {
        this.error = error.status;
        if (error.status === 401) {
          this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
        } else  {
          this.mensajeError = '¡Error!';
        }
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
          $('#mod_error').modal('show');
        }, 500);
    });
  }

  readProcedimientos(anio: string, idPantalla: number, idProveedor: string, perfil: string) {
    this.apiProcedimientos.getListaProcs(anio, idPantalla, idProveedor, perfil).subscribe(data => {
      if(data[0].success){
        this.procedimientos = JSON.parse(data[0].info);
        $(document).ready(function () {
          let datatable = $('#tbl_proc_proveedor').DataTable({
            /*dom: "<'row'<'col-sm-12 col-md-6'l><'col-sm-12 col-md-6 toolbar'>>" +
                  "<'row'<'col-sm-12'tr>>" +
                  "<'row'<'col-sm-12 col-md-6'><'col-sm-12 col-md-6'p>>",*/

            //dom: '<"#positionFilter">ltp',
        paging: true,       //Oculta controles y etiquetas de paginación
        searching: true,    //Dejar en true para conservar funcionalidades de busqueda en columnas.
        info: false,        //Oculta etiquetas de cantidad de registros disponibles y filtrados.
        autoWidth: false,   //Impide que calcule automaticamente el ancho de las columnas.
        processing: true,
        bSort: false,
        renderer: 'bootstrap',
        dom: "<'row'<'col-sm-10'B><'col-sm-2 toolbar'>>tp",
        "lengthMenu": [[10, 25, 50, -1], ["Mostrar 10", "Mostrar 25", "Mostrar 50", "Mostrar Todos"]],
        language: {
          "sSearch": "Buscar:",
          "sProcessing": "Procesando...",
          "sLengthMenu": "_MENU_ REGISTROS",
          "sZeroRecords": "No se encontraron resultados",
          "sEmptyTable": "Ningún dato disponible en esta tabla",
          "sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
          "sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
          "sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
          "sInfoPostFix": "",
          "oPaginate": {
              "sFirst": "Primero",
              "sLast": "Último",
              "sNext": "SIGUIENTE",
              "sPrevious": "ANTERIOR"
          },
          buttons: {
              pageLength: {
                  _: '<span><i class="fal fa-list-ul mr-2"></i></span> %d REGISTROS',
                  //1: '<span><i class="fal fa-list-ul mr-2"></i></span> Mostrar Todos',
                  '-1': '<span><i class="fal fa-list-ul mr-2"></i></span> Mostrar Todos'
              }
          }
      },
      buttons: [
            {
              extend: 'pageLength',
              className: 'btn uaa-btn-outline btn-sm dropdown-toggle'
          }
      ]
      ,
            "columnDefs": [
              { "searchable": true, "targets": 8 },
              { "visible": false, "targets": [8,9] },
              {
                  targets: 3,
                  render: (data, type, row) => {
                      if (type === 'display') {
                        if ( row["9"] ==='1'){
                          return data+'<br><span class="uaa-cred" data-toggle="tooltip" data-placement="top" title="*El estatus pre asignado no genera un compromiso para la UAA, no deberá considerarse como un pedido. ">*El estatus pre asignado no genera un compromiso para la UAA, no deberá considerarse como un pedido. </span>';
                        }
                      }
                      return data;
                  }
                  //render: $.fn.dataTable.render.ellipsis(100)
              }
            ]
          });
          $('[data-toggle="tooltip"]').tooltip();
          $("div.toolbar").html('<span class="uaa-cgreen float-right"><i class="mdi mdi-trophy-award uaa-trophy"></i>= Indica que usted ha sido pre-asignada</span>');

          $('#myInput').on( 'keyup', function () {
            datatable.search( this.value ).draw();
          });

          $('#btn_todos').on('click', function() {
            datatable.columns(8).search('');
            datatable.draw();
            $('#btn_todos').addClass('active');
            $('#btn_mios').removeClass('active');
            $('#btn_ordenes').removeClass('active');

            $('#lbl_titulo').text('Todos los Procedimientos');
            $('#div_participaciones').show();
            $('#div_ordenes').hide();
          });

          $('#btn_mios').on('click', function() {
            datatable.columns(8).search('1');
            datatable.draw();
            $('#btn_todos').removeClass('active');
            $('#btn_mios').addClass('active');
            $('#btn_ordenes').removeClass('active');

            $('#lbl_titulo').text('Mis Participaciones');
            $('#div_participaciones').show();
            $('#div_ordenes').hide();
          });

          $('#btn_ordenes').on('click', function() {
            $('#lbl_titulo').text('Mis Órdenes de Compra');
            $('#btn_todos').removeClass('active');
            $('#btn_mios').removeClass('active');
            $('#btn_ordenes').addClass('active');

            $('#div_participaciones').hide();
            $('#div_ordenes').show();
          });
        })

        setTimeout(() => {
          $('#mod_procesando').modal('hide');
        }, 500);
      } else {
        this.mensajeError = data[0].msgRespuesta;
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
          $('#mod_error').modal('show');
        }, 500);
      }
    },
    error => {
      this.error = error.status;
      if (error.status === 401) {
        this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
      } else  {
        this.mensajeError = '¡Error!';
      }
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#mod_error').modal('show');
      }, 500);
    });
  }

  getRuta(iactido: string, anio: string, idProc: string){
    let ruta: string;

    if (iactido === this.globals.IACTIDO_PROC_OBRA) {
        ruta = '/menu-obra';
    }

    if (iactido === this.globals.IACTIDO_PROC_ADQUISICION) {
      ruta = '/menu-producto';
    }

    this.apiParams.setIdProcedimiento(idProc, anio);
    this.router.navigateByUrl(ruta);
  }

  cerrarSesion() {
    this.apiAuth.deleteToken();
    this.router.navigate(['/']).then(() => window.location.reload());
  }
  cargar() {
    this.router.navigate(['/procs']).then(() => window.location.reload());
  }
}
